/**
 * User Management Hooks
 * TanStack Query hooks for admin user management
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { userManagementRepo } from '@/lib/repositories'
import { analytics } from '@/lib/services/analytics'
import { AnalyticsEvents } from '@/lib/services/analytics-events'

export const USERS_KEY = ['admin-users'] as const

export function useUsers() {
  return useQuery({
    queryKey: USERS_KEY,
    queryFn: () => userManagementRepo.listUsers(),
    staleTime: 30_000,
  })
}

export function useApproveUser() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (userId: string) => userManagementRepo.approveUser(userId),
    onSuccess: (_, userId) => {
      queryClient.invalidateQueries({ queryKey: USERS_KEY })
      analytics.capture(AnalyticsEvents.ADMIN_USER_APPROVED, { user_id: userId })
    },
  })
}

export function useRevokeUser() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (userId: string) => userManagementRepo.revokeUser(userId),
    onSuccess: (_, userId) => {
      queryClient.invalidateQueries({ queryKey: USERS_KEY })
      analytics.capture(AnalyticsEvents.ADMIN_USER_REVOKED, { user_id: userId })
    },
  })
}
